import React from "react";
import { ThemeProvider as StyledComponentThemeProvider } from "styled-components";
import { theme } from "theme/theme";

const ThemeProvider: Component = ({ children }) => {
  return <StyledComponentThemeProvider theme={{ ...theme }}>{children}</StyledComponentThemeProvider>;
};

export default ThemeProvider;
